const COUNTRY_CURRENCY_CONFIG = {
  PT: { localPrefix: "€", usdPerLocalUnit: 1.08, source: "local", localIsUsd: false },
  ES: { localPrefix: "€", usdPerLocalUnit: 1.08, source: "local", localIsUsd: false },
  FR: { localPrefix: "€", usdPerLocalUnit: 1.08, source: "local", localIsUsd: false },
  DE: { localPrefix: "€", usdPerLocalUnit: 1.08, source: "local", localIsUsd: false },
  NL: { localPrefix: "€", usdPerLocalUnit: 1.08, source: "local", localIsUsd: false },
  IT: { localPrefix: "€", usdPerLocalUnit: 1.08, source: "local", localIsUsd: false },
  GR: { localPrefix: "€", usdPerLocalUnit: 1.08, source: "local", localIsUsd: false },
  HR: { localPrefix: "€", usdPerLocalUnit: 1.08, source: "local", localIsUsd: false },
  JP: { localPrefix: "¥", usdPerLocalUnit: 0.0067, source: "local", localIsUsd: false },
  SG: { localPrefix: "S$", usdPerLocalUnit: 0.74, source: "local", localIsUsd: false },
  CA: { localPrefix: "C$", usdPerLocalUnit: 0.73, source: "local", localIsUsd: false },
  AU: { localPrefix: "A$", usdPerLocalUnit: 0.66, source: "local", localIsUsd: false },
  NZ: { localPrefix: "NZ$", usdPerLocalUnit: 0.60, source: "local", localIsUsd: false },
  MX: { localPrefix: "MX$", usdPerLocalUnit: 0.059, source: "usd", localIsUsd: false },
  CR: { localPrefix: "₡", usdPerLocalUnit: 0.00198, source: "usd", localIsUsd: false },
  PA: { localPrefix: "US$", usdPerLocalUnit: 1, source: "usd", localIsUsd: true },
  TH: { localPrefix: "฿", usdPerLocalUnit: 0.0278, source: "usd", localIsUsd: false },
  MY: { localPrefix: "RM", usdPerLocalUnit: 0.213, source: "usd", localIsUsd: false },
  EC: { localPrefix: "US$", usdPerLocalUnit: 1, source: "usd", localIsUsd: true },
  CO: { localPrefix: "COP ", usdPerLocalUnit: 0.00026, source: "usd", localIsUsd: false },
  VN: { localPrefix: "₫", usdPerLocalUnit: 0.000039, source: "usd", localIsUsd: false },
  UY: { localPrefix: "UYU ", usdPerLocalUnit: 0.025, source: "usd", localIsUsd: false },
  AR: { localPrefix: "ARS ", usdPerLocalUnit: 0.00095, source: "usd", localIsUsd: false },
  CL: { localPrefix: "CLP ", usdPerLocalUnit: 0.00105, source: "usd", localIsUsd: false },
};

const DEFAULT_CONFIG = { localPrefix: "$", usdPerLocalUnit: 1, source: "usd", localIsUsd: true };

const parseRangeValues = (rangeText = "") => {
  const values = Array.from(rangeText.matchAll(/\d[\d,]*/g), (match) => Number(match[0].replace(/,/g, "")));
  if (!values.length) return null;
  const hasPlus = /\+/.test(rangeText);
  return {
    min: values[0],
    max: values[1] || values[0],
    hasPlus,
    cadence: /\/\s*year/i.test(rangeText) ? "year" : "month",
  };
};

const roundApproxAmount = (value = 0) => {
  if (value >= 1000000) return Math.round(value / 50000) * 50000;
  if (value >= 100000) return Math.round(value / 5000) * 5000;
  if (value >= 10000) return Math.round(value / 500) * 500;
  if (value >= 1000) return Math.round(value / 50) * 50;
  return Math.round(value / 10) * 10;
};

const formatAmount = (value = 0) => new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
}).format(Math.max(0, Math.round(value)));

const formatRange = (prefix, min, max, hasPlus, cadence = "month") => {
  const minText = `${prefix}${formatAmount(min)}`;
  const maxText = `${prefix}${formatAmount(max)}`;
  const rangeText = min === max
    ? `${minText}${hasPlus ? "+" : ""}`
    : `${minText}–${maxText}${hasPlus ? "+" : ""}`;
  return `${rangeText} / ${cadence}`;
};

const formatRangeWithoutCadence = (prefix, min, max, hasPlus) => {
  const minText = `${prefix}${formatAmount(min)}`;
  const maxText = `${prefix}${formatAmount(max)}`;
  return min === max
    ? `${minText}${hasPlus ? "+" : ""}`
    : `${minText}–${maxText}${hasPlus ? "+" : ""}`;
};

export const getCountryCostRangePresentation = (countryCode, rangeText = "") => {
  const parsed = parseRangeValues(rangeText);
  if (!parsed) {
    return {
      displayRange: rangeText,
      usdRangeText: rangeText,
      localRangeText: rangeText,
    };
  }

  const config = COUNTRY_CURRENCY_CONFIG[countryCode] || DEFAULT_CONFIG;
  const usdMin = config.source === "local"
    ? roundApproxAmount(parsed.min * config.usdPerLocalUnit)
    : parsed.min;
  const usdMax = config.source === "local"
    ? roundApproxAmount(parsed.max * config.usdPerLocalUnit)
    : parsed.max;
  const localMin = config.source === "local"
    ? parsed.min
    : roundApproxAmount(parsed.min / config.usdPerLocalUnit);
  const localMax = config.source === "local"
    ? parsed.max
    : roundApproxAmount(parsed.max / config.usdPerLocalUnit);

  const localRangeText = formatRange(config.localPrefix, localMin, localMax, parsed.hasPlus, parsed.cadence);
  const usdRangeText = formatRange("$", usdMin, usdMax, parsed.hasPlus, parsed.cadence);

  return {
    displayRange: config.localIsUsd
      ? localRangeText
      : `${localRangeText} (≈${formatRangeWithoutCadence("$", usdMin, usdMax, parsed.hasPlus)} USD)`,
    usdRangeText,
    localRangeText,
  };
};